module.exports = __webpack_public_path__ + "static/img/ringone_banner.fba0e09.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ringone_banner.png
// module id = B9Uz
// module chunks = 1